import { render, staticRenderFns } from "./DueDiligenceTractDetails.vue?vue&type=template&id=2c6c6be0&scoped=true&"
import script from "./DueDiligenceTractDetails.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceTractDetails.vue?vue&type=script&lang=js&"
import style0 from "./DueDiligenceTractDetails.vue?vue&type=style&index=0&id=2c6c6be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c6be0",
  null
  
)

export default component.exports